import DocumentTitle from 'react-document-title';
import moment from 'moment';
import React from 'react';
import sortByOrder from 'lodash/collection/sortByOrder';
import { Link, State } from 'react-router';
import { templateChildrenPages } from 'gatsby-helpers';

import ReindexTypography from '../ui/_ReindexTypography';

const { rhythm } = ReindexTypography;
const mutedColor = '#848484';
const styles = {
  post: {
    display: 'flex',
    marginBottom: rhythm(1),
  },
  postContent: {
    flex: 1,
  },
  postLink: {
    textDecoration: 'none',
  },
  authorImage: {
    borderRadius: '50%',
    width: 64,
    height: 64,
    margin: '0 20px 0 0',
  },
  meta: {
    color: mutedColor,
    fontSize: '13px',
    textTransform: 'uppercase',
    marginBottom: '0.3em',
    fontWeight: 300,
    letterSpacing: '1px',
  },
};

const BlogIndex = React.createClass({
  mixins: [State],

  render() {
    let childPages = templateChildrenPages(__filename, this.props.state)
      .filter((child) => child.data)
      .map((child) => ({
        ...child.data,
        path: child.path,
      }));
    childPages = sortByOrder(childPages, ['date'], ['desc']);

    const posts = childPages.map((post) => {
      const { author } = post;
      const date = moment(post.date).locale('en');
      return (
        <div style={styles.post} key={post.path}>
          <img src={author.image} style={styles.authorImage} />
          <div style={styles.postContent}>
            <h2>
              <Link to={post.path} style={styles.postLink}>
                {post.title}
              </Link>
            </h2>
            <p>{post.excerpt}</p>
            <div style={styles.meta}>
              By {author.name} &mdash;
              {' '}
              <time pubdate dateTime={date.toISOString()}>
                {date.format('MMMM Do, YYYY')}
              </time>
            </div>
          </div>
        </div>
      );
    });
    return (
      <DocumentTitle
        title="Blog | Reindex">
        <ul style={{ margin: 0 }}>
          {posts}
        </ul>
      </DocumentTitle>
    );
  },
});

export default BlogIndex;



/** WEBPACK FOOTER **
 ** ./blog/index.jsx
 **/